import React from 'react';
import { numberFormatter } from '../../formatter';
import { YOUTUBE } from '../../constants';

export function maskValueCell(props, decimals = 2, format='currency') {

    let propertyValue = props.dataItem[props.field];
    if(props.field.includes('.')) {
        const [ objectProperty, fieldName ] = props.field.split('.');
        propertyValue = props.dataItem[objectProperty][fieldName];
    }

    let displayValue = propertyValue;
    
    switch(format){
        case 'currency':
            displayValue = numberFormatter.formatAsCurrency(propertyValue, decimals);
            break;
        case 'percentage':
            displayValue = numberFormatter.formatAsPercentage(propertyValue, decimals);
            break;
        default:
            break;
    }

    return (
        <td>
            {displayValue} 
        </td>
    );
}

export function channelCell(props) {
    let cellComponent = null;

    const channelMedium = props.dataItem.medium;
    const channelMediumName = channelMedium && channelMedium.name;
    const iconName = channelMediumName || YOUTUBE;

    const channelUrl = channelMedium && (channelMedium.channel_url_prefix + props.dataItem.channelMediumId);

    if(channelUrl) {
        cellComponent = (<>
                            <a href={channelUrl} target="blank" className='channel-name'>
                                {props.dataItem[props.field]}  
                                <img
                                    className="medium-icon"
                                    src={`/icons/networks/${iconName.toLowerCase()}.svg`}
                                    alt={`${iconName} Icon`}
                                    title={`${iconName} Icon`}
                                />
                                
                            </a>
                        </>);
    } else {
        cellComponent = props.dataItem[props.field];
    }

    return (
        <td className="highlight">
            {cellComponent}
        </td>
    );
}
